import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CryptoJS from 'crypto-js';

import { setAccount } from 'actions/app';
import FormGroupTypes from 'common/forms/formGroupTypes';
import { injectIntl } from 'react-intl';

import LocalisedMessage from 'components/Common/LocalisedMessage';
import FormSelectionCard from 'components/FormSelectionCard';
import FormChoiceModal from 'components/Modals/FormChoiceModal';

const FormSelection = ({ formTypes, formGroups, selectedFormtype, isFormChoiceShown, customerName, usePreQualifyingQuestionnaire, customerAccounts, dispatch, selectedAccountId, intl }) => {
  useEffect(() => {
    if (customerAccounts && customerAccounts.length === 1) {
      dispatch(setAccount(customerAccounts[0].id));
    } else {
      dispatch(setAccount(selectedAccountId));
    }
  }, []);

  const isCrsParticipating = usePreQualifyingQuestionnaire && (selectedAccountId ? customerAccounts.filter(x => x.id === selectedAccountId && x.isCrsParticipating).length > 0 : false);

  return (<section className="form-selection">
    <div className="row">
      <div className="col">
        <div className="tooltip mobile-username">
          <div className="row m-0">
            <span className="text-left"><FontAwesomeIcon icon="user-circle" size="lg" /></span>
            <h3 className="col-10 text-left" data-tooltip={ customerName } data-tooltip-conf="bottom">{ customerName }</h3>
            <span className="tooltiptext">{ customerName }</span>
          </div>
        </div>
        <h1><LocalisedMessage id="formSelection.header" /></h1>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <LocalisedMessage id="formSelection.welcome" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        { usePreQualifyingQuestionnaire && <div className="link">
          <p><LocalisedMessage id="formSelection.preQuestionnaireText" /><Link to="/" className="btn btn-link"> <LocalisedMessage id="formSelection.preQuestionnaireLink" /></Link></p>
        </div> }
      </div>
    </div>
    {customerAccounts === null && <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <h3 className="error"><LocalisedMessage id="formSelection.incompleteAccountText" /></h3>
        </div>
      </div>
    </div>}
    { customerAccounts && customerAccounts.length > 1 && <div className="row align-to-card">
      <div className="col-md-12 col-lg-8">
        <div className="form-group">
          <label htmlFor="customer-accounts"><h3><LocalisedMessage id="formSelection.accountCertifyingForText" /></h3>
            <select id="customer-accounts" defaultValue={ selectedAccountId } onChange={ event => dispatch(setAccount(event.target.value)) }>
              <option value="0">{ intl.formatMessage({ id: 'formSection.accountSelectText' }) }</option>
              { customerAccounts && customerAccounts.map(i => <option key={ i.id } value={ i.id }>{ i.displayName }</option>) }
            </select>
          </label>
        </div>
      </div>
    </div>}
    <div className="row">
      <div className="col p-0">
        <div className="form-group">
          <div className="row cards">
            { formTypes && formTypes.map(item => item.isVisible && <div key={ item.formType } className="col-md-6 col-lg-4">
              <FormSelectionCard { ...item } />
            </div>) }
            { formGroups && formGroups.map(item => item.isVisible && (selectedAccountId > 0 && (!item.crsRestricted || (item.crsRestricted && isCrsParticipating))) && <div key={ item.formType } className="col-md-6 col-lg-4">
              <FormSelectionCard { ...item } formGroup={ FormGroupTypes.find(group => group.key === item.formType) } />
            </div>)}
            { isFormChoiceShown
              && <FormChoiceModal
                formType={ selectedFormtype }
              /> }
          </div>
        </div>
      </div>
    </div>
  </section>);
};

FormSelection.propTypes = {
  dispatch: PropTypes.func.isRequired,
  formTypes: PropTypes.arrayOf(PropTypes.shape({})),
  formGroups: PropTypes.arrayOf(PropTypes.shape({})),
  selectedFormtype: PropTypes.string,
  isFormChoiceShown: PropTypes.bool,
  customerName: PropTypes.string.isRequired,
  usePreQualifyingQuestionnaire: PropTypes.bool,
  selectedAccountId: PropTypes.number,
  customerAccounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    displayName: PropTypes.string
  })),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

FormSelection.defaultProps = {
  formTypes: [],
  formGroups: [],
  selectedFormtype: '',
  isFormChoiceShown: false,
  usePreQualifyingQuestionnaire: false,
  selectedAccountId: 0,
  customerAccounts: []
};

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig,
      customerData,
      key
    },
    form: {
      formType,
      isFormChoiceShown,
      selectedAccountId
    }
  } = state;

  const decryptedArray = customerData ? CryptoJS.AES.decrypt(customerData, key) : null;
  const decryptedText = decryptedArray ? decryptedArray.toString(CryptoJS.enc.Utf8) : null;
  const customerDetails = decryptedText ? JSON.parse(decryptedText) : null;

  return {
    formTypes: onlineConfig && onlineConfig.formTypes,
    formGroups: onlineConfig && onlineConfig.formGroups,
    selectedFormtype: formType,
    isFormChoiceShown,
    customerName: customerDetails && customerDetails.CustomerName,
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
    customerAccounts: onlineConfig && onlineConfig.customer && onlineConfig.customer.accounts,
    selectedAccountId
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(FormSelection));
